<template>
  <LoggedInContainer :hideAppBar="true">
    <ProjectSubmenu></ProjectSubmenu>
    <router-view v-if="selectedProject.id && selectedPage.id"></router-view>
  </LoggedInContainer>
</template>

<script>
import LoggedInContainer from "../../components/LoggedInContainer";
import ProjectSubmenu from "../../components/project/ProjectSubmenu";
import projectMixin from "../../components/project/project-mixin";

export default {
  components: {
    LoggedInContainer,
    ProjectSubmenu,
  },
  mixins: [projectMixin],
  async created() {
    this.SET_SELECTED_PROJECT({ id: "", name: "" });
    this.SET_SELECTED_PAGE({ id: "", name: "" });
    this.SET_SELECTED_PAGE_BLOCKS([]);
    this.SET_SELECTED_PROJECT_PAGES([]);
    await this.getProject(this.$route.params.id);
    document.title = this.selectedProject.name + " - Landly Console";
    await this.getProjectPages(this.$route.params.id);
    this.hubConnectToSocket(() => {
      this.hubJoinProjectGroup(parseInt(this.$route.params.id));
      this.subscribeToEvents(this.$route.params.id);
    });
    if (this.projectPages.length > 0) {
      this.SET_SELECTED_PAGE(this.projectPages[0]);
      await this.getPageBlocks();
    }
  },
  destroyed() {
    this.hubLeaveProjectGroup(this.selectedProject.id);
  },
};
</script>